import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import LoadingPage from "../../../services/LoadingPage";
import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { Grid, Typography } from "@material-ui/core";
import FooterA from "../../Safes/Jard/A4/FooterA";
import { Rept } from "../../../Context/InshData";
import useChunkMyData from "../../../components/Hooks/useChunkMyData";
import { useLocation } from "react-router-dom";
import { sto } from "../../../Context/InshData";

import BodySalesman from "./A4/BodySa";
import HeaderSalesman from "./A4/HeaderSa";
function BillPage(props) {

    const { chunk, isFirst, isLast,info } = props;

    return (
        <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>

            <Fragment>
                <Grid xs={12} item style={{ maxHeight: "27.5cm", minHeight: "27.5cm" }}>
                    {isFirst && <HeaderSalesman info={info}/>}
                    <BodySalesman
                        data={chunk ?? []}
                        isLast={isLast}
                    />
                </Grid>

                <Grid xs={12} item style={{ maxHeight: "1.8cm", minHeight: "1.8cm" }}>
                    <FooterA found={info}
                        isLast={isLast} />
                </Grid>
            </Fragment>
        </Grid>
    );
}
function RevSalesmanContianer(props) {
    const loc = useLocation();
    const { chunks, chunksCount } = useChunkMyData(Rept.data, 25, 32);
    const [info, setInfo] = useState({});

    const [loading, setLoading] = useState(true);

    
    const getInfo = async () => {
        axios
          .get(uri + `Foundation?branch=${sto.branchi}`)
          .then((res) => {
            setInfo(res.data);
          })
          .catch((error) => {});
      };
    
      useEffect(() => {
        setTimeout(async () => {
          await getInfo();
          setLoading(false);
          // onUnmountComplete();
        }, 0);
      }, []);

      if (!info || loading) return <LoadingPage />;



    return (
        <Typography component="div" style={stElemnt.AF.Reviws.ReviwsJard}>

            <Typography component="div" >
                {chunks.map((page, i) => {
                    return (
                        <BillPage
                            {...{
                                chunk: page,
                                isFirst: i == 0,
                                isLast: i == chunksCount - 1,
                                info,
                            }}
                        />
                    );
                })}
            </Typography>
        </Typography>
    );
}
export default RevSalesmanContianer;
